import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';
import logoVideo from '../assets/demo/LOGO-VIDEO-cropped.png';
import { services } from '../data/portfolio';
import { fadeIn } from '../variants';

const Services = ({ onSelectService }) => {
  return (
    <section id='bookings' className='page-section flex items-center'>
      <div className='section-shell'>
        <motion.div
          variants={fadeIn('up', 0.1)}
          initial={false}
          whileInView='show'
          viewport={{ once: true, amount: 0.3 }}
          className='mb-12'
        >
          <p className='section-kicker'>Bookings</p>
          <h2 className='section-title'>What I do</h2>
        </motion.div>

        <div className='grid items-center gap-10 xl:grid-cols-[2fr_1fr]'>
          <div className='grid gap-8'>
            {services.map((service, index) => (
              <motion.article
                key={service.number}
                variants={fadeIn('right', index * 0.08)}
                initial={false}
                whileInView='show'
                viewport={{ once: true, amount: 0.25 }}
                className='group border-b border-white/20 pb-9'
              >
                <div className='mb-6 flex items-start justify-between gap-6'>
                  <span className='text-[44px] font-extrabold leading-none text-white transition group-hover:text-accent'>
                    {service.number}
                  </span>
                  <a
                    href='#contact'
                    onClick={() => onSelectService?.(service.title)}
                    className='inline-flex h-[54px] w-[54px] items-center justify-center rounded-full bg-white text-primary transition group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:bg-accent'
                    aria-label={`Ask about ${service.title}`}
                    title={`Ask about ${service.title}`}
                  >
                    <FiArrowUpRight size={24} />
                  </a>
                </div>
                <h3 className='mb-4 text-[28px] font-bold leading-tight text-white transition group-hover:text-accent md:text-[34px]'>
                  {service.title}
                </h3>
                <p className='max-w-[620px] text-base leading-8 text-white/60'>
                  {service.description}
                </p>
              </motion.article>
            ))}
          </div>

          <motion.div
            variants={fadeIn('left', 0.16)}
            initial={false}
            whileInView='show'
            viewport={{ once: true, amount: 0.25 }}
            className='mt-8 flex min-h-[380px] items-center justify-center overflow-visible xl:mt-0 xl:h-full xl:min-h-[420px] xl:justify-end'
          >
            <img
              className='h-full max-h-[520px] w-full origin-center scale-100 object-contain drop-shadow-[0_28px_80px_rgba(0,0,0,0.35)] xl:scale-[1.3]'
              src={logoVideo}
              alt='Action Fifi logo'
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;
